/** カート追加ボタン */
class CartAddButton extends HTMLElement {
  constructor() {
    super();

    this.variantId = this.dataset.variantId ? parseInt(this.dataset.variantId, 10) : undefined;
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.addCart(this.variantId);
    });
  }

  /** カートに商品を追加 */
  async addCart(variantId) {
    if (!variantId) {
      window.alert("商品IDの取得に失敗しました");
      console.error("Validation Error:", "[variantId]", variantId);
      return;
    }

    const buttonElement = this.querySelector("button");
    const loadingClassName = "button--loading";
    buttonElement.classList.add(loadingClassName);

    try {
      const result = await fetch(`${routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });
      if (!result.ok) {
        console.error("POST Error:", result);
        buttonElement.classList.remove(loadingClassName);
        window.alert("商品の追加に失敗しました");
        return;
      }
      const response = await result.json();
      if (response.status) {
        console.error("POST Error:", response);
        window.alert(response.description);
        return;
      }
      window.alert("商品をショッピングバックに追加しました");

      // ページをリロードして更新
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
      window.alert("商品の追加に失敗しました");
    }

    buttonElement.classList.remove(loadingClassName);
  }
}
customElements.define('cart-add-button', CartAddButton);

/** カート削除ボタン */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.lineKey = this.dataset.lineKey;
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.removeCart(this.lineKey);
    });
  }

  /** カートに商品を追加 */
  async removeCart(lineKey) {
    if (!lineKey) {
      window.alert("商品IDの取得に失敗しました");
      console.error("Validation Error:", "[lineKey]", lineKey);
      return;
    }

    const buttonElement = this.querySelector("button");
    const loadingClassName = "button--loading";
    buttonElement.classList.add(loadingClassName);

    try {
      const result = await fetch(`${routes.cart_change_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
        }),
      });
      if (!result.ok) {
        console.error("POST Error:", result);
        buttonElement.classList.remove(loadingClassName);
        window.alert("商品の削除に失敗しました");
        return;
      }
      const response = await result.json();
      if (response.status) {
        console.error("POST Error:", response);
        buttonElement.classList.remove(loadingClassName);
        window.alert(response.description);
        return;
      }
      window.alert("商品をショッピングバックから削除しました");

      // ページをリロードして更新
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
      buttonElement.classList.remove(loadingClassName);
      window.alert("商品の削除に失敗しました");
    }
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

/** カート更新ボタン */
class CartUpdateButton extends HTMLElement {
  constructor() {
    super();

    this.lineKey = this.dataset.lineKey;
    this.quantity = this.dataset.quantity;
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.updateCart(this.lineKey, this.quantity);
    });
  }

  /** カートの商品の数量を更新 */
  async updateCart(lineKey, quantity) {
    if (!lineKey) {
      window.alert("商品IDの取得に失敗しました");
      console.error("Validation Error:", "[lineKey]", lineKey);
      return;
    }
    if (quantity === undefined) {
      window.alert("数量の取得に失敗しました");
      console.error("Validation Error:", "[quantity]", quantity);
      return;
    }

    const buttonElement = this.querySelector("button");
    const loadingClassName = "button--loading";
    buttonElement.classList.add(loadingClassName);

    try {
      const result = await fetch(`${routes.cart_change_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity,
        }),
      });
      if (!result.ok) {
        console.error("POST Error:", result);
        buttonElement.classList.remove(loadingClassName);
        window.alert("商品の数量の更新に失敗しました");
        return;
      }
      const response = await result.json();
      if (response.status) {
        console.error("POST Error:", response);
        buttonElement.classList.remove(loadingClassName);
        window.alert(response.description);
        return;
      }

      // ページをリロードして更新
      window.location.reload();
    } catch (error) {
      console.error("Error:", error);
      buttonElement.classList.remove(loadingClassName);
      window.alert("商品の数量の更新に失敗しました");
    }
  }
}
customElements.define('cart-update-button', CartUpdateButton);
